export const FilesIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.875 3.75H9.375C7.25368 3.75 6.19302 3.75 5.53401 4.40901C4.875 5.06802 4.875 6.12868 4.875 8.25V12C4.875 14.1213 4.875 15.182 5.53401 15.841C6.19302 16.5 7.25368 16.5 9.375 16.5H10.3823C10.9955 16.5 11.3021 16.5 11.5777 16.3859C11.8534 16.2716 12.0701 16.0549 12.5037 15.6213L14.4963 13.6287C14.9299 13.1951 15.1466 12.9784 15.2609 12.7027C15.375 12.4271 15.375 12.1205 15.375 11.5073V8.25C15.375 6.12868 15.375 5.06802 14.716 4.40901C14.057 3.75 12.9963 3.75 10.875 3.75Z"
        stroke="#31394A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.25 16.125V15.375C11.25 13.9608 11.25 13.2537 11.6894 12.8144C12.1287 12.375 12.8358 12.375 14.25 12.375H15"
        stroke="#31394A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.875 14.25C3.63236 14.25 2.625 13.2427 2.625 12V6C2.625 3.87868 2.625 2.81802 3.28401 2.15901C3.94302 1.5 5.00368 1.5 7.125 1.5H10.8753C12.1179 1.50001 13.1253 2.50739 13.1253 3.75002"
        stroke="#31394A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.50082 9.75H10.5008M7.50082 6.75H12.7508"
        stroke="#31394A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
